import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { formatRupiah } from '../../utils/currency';
import { formatNumber } from '../../utils/number';

const TAB_KEYS = ['most_viewed', 'most_favorited', 'most_inquired', 'low_performance'];

const TABS = [
  { key: 'most_viewed', label: 'Terpopuler' },
  { key: 'most_favorited', label: 'Favorit' },
  { key: 'most_inquired', label: 'Banyak Inquiry' },
  { key: 'low_performance', label: 'Kinerja Rendah' },
];

const getCountKey = (tabKey) => {
  switch (tabKey) {
    case 'most_viewed': return 'view_count';
    case 'most_favorited': return 'favorite_count';
    case 'most_inquired': return 'inquiry_count';
    case 'low_performance': return 'view_count';
    default: return 'view_count';
  }
};

const getTabEmptyMessage = (tabKey) => {
  switch (tabKey) {
    case 'most_viewed': return 'Belum ada data tampilan properti.';
    case 'most_favorited': return 'Belum ada properti yang difavoritkan.';
    case 'most_inquired': return 'Belum ada inquiry properti.';
    case 'low_performance': return 'Tidak ada properti dengan kinerja rendah.';
    default: return 'Tidak ada data.';
  }
};

const PerformanceTable = ({ data, tabKey }) => {
  const countKey = getCountKey(tabKey);

  if (!data || data.length === 0) {
    return <div className="analytics-empty">{getTabEmptyMessage(tabKey)}</div>;
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="performance-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Properti</th>
            <th>Lokasi</th>
            <th>Harga</th>
            <th>
              {tabKey === 'most_viewed' ? 'Dilihat' : tabKey === 'most_favorited' ? 'Favorit' : tabKey === 'most_inquired' ? 'Inquiry' : 'Dilihat'}
            </th>
            {tabKey === 'low_performance' && <th>Inquiry</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
              <td style={{ color: '#94a3b8', fontWeight: 700 }}>{index + 1}</td>
              <td>
                <Link
                  to={`/dashboard/properties/${item.slug || item.id}`}
                  className="performance-table__title"
                >
                  {item.title}
                </Link>
              </td>
              <td style={{ color: '#64748b' }}>{item.city || item.province || '-'}</td>
              <td style={{ fontWeight: 700 }}>{formatRupiah(item.price)}</td>
              <td>
                <span className={`performance-table__badge ${
                  tabKey === 'low_performance'
                    ? 'performance-table__badge--low'
                    : index < 3
                      ? 'performance-table__badge--high'
                      : 'performance-table__badge--medium'
                }`}>
                  {formatNumber(item[countKey] || 0)}
                </span>
              </td>
              {tabKey === 'low_performance' && (
                <td>
                  <span className="performance-table__badge performance-table__badge--low">
                    {formatNumber(item.lead_count || 0)}
                  </span>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const PropertyPerformance = ({ data }) => {
  const [activeTab, setActiveTab] = useState('most_viewed');

  if (!data) return null;

  return (
    <div className="section-card">
      <div className="section-card__header">
        <h3 className="section-card__title">Kinerja Properti</h3>
      </div>

      <div className="section-card__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`section-card__tab ${activeTab === tab.key ? 'section-card__tab--active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="section-card__body">
        <PerformanceTable data={data[activeTab]} tabKey={activeTab} />
      </div>
    </div>
  );
};

export default PropertyPerformance;
